export default {
  'projectSettings.detail.title': 'プロジェクト詳細',
  'projectSettings.detail.subtitle': '現在のプロジェクト情報を編集します',
  'projectSettings.detail.basicInfo': '基本情報',
  'projectSettings.detail.unsaved': '未保存の変更があります',
  'projectSettings.detail.refresh': '更新',
  'projectSettings.detail.edit': 'プロジェクトを編集',
  'projectSettings.detail.noContext':
    'このページのプロジェクト情報が見つかりません',
  'projectSettings.detail.loadError': 'プロジェクト詳細を読み込めませんでした',
  'projectSettings.detail.loadErrorHint':
    'ネットワーク接続を確認して再試行してください。',
  'projectSettings.detail.retry': '再試行',
  'projectSettings.detail.logoPreview': 'プレビュー',
  'projectSettings.detail.priority': '優先度',
  'projectSettings.detail.cnName': 'プロジェクト名',
  'projectSettings.detail.name': '英語名',
  'projectSettings.detail.identifier': 'プロジェクト識別子',
  'projectSettings.detail.prefix': 'プロジェクト略称',
  'projectSettings.detail.group': 'プロジェクトグループ',
  'projectSettings.detail.group.none': 'グループなし',
  'projectSettings.detail.group.loadError':
    'プロジェクトグループを読み込めませんでした。後でもう一度お試しください。',
  'projectSettings.detail.tags': 'プロジェクトタグ',
  'projectSettings.detail.status': 'プロジェクト状態',
  'projectSettings.detail.status.initiation': '立ち上げ',
  'projectSettings.detail.status.requirements': '要件分析',
  'projectSettings.detail.status.design': '設計中',
  'projectSettings.detail.status.development': '開発中',
  'projectSettings.detail.status.testing': 'テスト中',
  'projectSettings.detail.status.launched': 'リリース済み',
  'projectSettings.detail.status.maintenance': '保守中',
  'projectSettings.detail.priority.low': '低',
  'projectSettings.detail.priority.medium': '中',
  'projectSettings.detail.priority.high': '高',
  'projectSettings.detail.priority.urgent': '緊急',
  'projectSettings.detail.logo': 'プロジェクト Logo URL',
  'projectSettings.detail.updatedAt': '最終更新',
  'projectSettings.detail.description': 'プロジェクト説明',
  'projectSettings.detail.empty': '未入力',
  'projectSettings.detail.editTitle': 'プロジェクト詳細を編集',
  'projectSettings.detail.save': '保存',
  'projectSettings.detail.cancel': 'キャンセル',
  'projectSettings.detail.cnNameRequired': 'プロジェクト名を入力してください',
  'projectSettings.detail.identifierRequired':
    'プロジェクト識別子を入力してください',
  'projectSettings.detail.identifierExists':
    'プロジェクト識別子は既に存在します',
  'projectSettings.detail.saveSuccess': 'プロジェクト詳細を更新しました',
  'projectSettings.detail.saveError':
    'プロジェクト詳細を更新できませんでした。後でもう一度お試しください。',
  'projectSettings.detail.previewHint':
    '現在はプレビュー状態です。「プロジェクトを編集」をクリックすると直接編集できます。',
  'projectSettings.detail.editingHint':
    'プロジェクト詳細を編集中です。完了したら保存してください。',
  'projectSettings.detail.discardTitle': '未保存の変更を破棄しますか？',
  'projectSettings.detail.discardContent':
    '現在の変更は保存されていません。編集モードを終了すると復元できません。',
  'projectSettings.detail.discard': '変更を破棄',
  'projectSettings.detail.continueEditing': '編集を続ける',
};
